import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../consts/actionTypes";
import * as API from "../api";

function* asyncGetCommunication({ payload }) {
  try {
    let response = '';
    if (payload !== '') {
      response = yield call(API.getCommunication);
    } else {
      response = yield call(API.getCommunication);
    }
    if (response)
      yield put({ type: actionTypes.SUCCESS_GET_COMMUNICATION, response, message: '' });
  } catch (error) {
    yield put({
      type: actionTypes.SEND_REQUEST_FAILURE,
      message: error.message,
    });
  }
}

function* asyncGetAllCommunications({ payload }) {
  try {
    var response = yield call(API.getAllCommunications, payload);
    if (response)
      yield put({
        type: actionTypes.SUCCESS_ALL_GET_COMMUNICATION,
        response,
        message: ''
      });
  } catch (error) {
    yield put({
      type: actionTypes.FAILURE_ALL_GET_COMMUNICATION,
      message: error.message,
    });
  }
}

function* asyncUpdateAllCommunications({ payload }) {
  try {
    yield put({
      type: actionTypes.SUCCESS_UPDATE_ALL_GET_COMMUNICATION,
      response: { data: payload },
      message: ''
    });
  } catch (error) {
    yield put({
      type: actionTypes.FAILURE_UPDATE_ALL_GET_COMMUNICATION,
      message: error.message,
    });
  }
}



function* asyncModifyCommunication({ payload }) {
  try {
    var res = yield call(API.modifyCommunication, payload);
    if (res)
      yield put({
        type: actionTypes.SUCCESS_MODIFY_COMMUNICATION,
        response: { data: true },
        message: ''
      });
  } catch (error) {
    yield put({
      type: actionTypes.FAILURE_MODIFY_COMMUNICATION,
      message: error.message,
    });
  }
}

function* asyncSelectCommunication({ payload }) {
  try {
    yield put({
      type: actionTypes.SUCCESS_SELECT_COMMUNICATION,
      response: { data: payload },
      message: ''
    });
  } catch (error) {
    yield put({
      type: actionTypes.FAILURE_SELECT_COMMUNICATION,
      message: error.message,
    });
  }
}

function* asyncSetCount({ payload }) {
  try {
    yield put({
      type: actionTypes.SUCCESS_SET_COUNT_COMMUNICATION,
      response: { data: payload },
      message: ''
    });
  } catch (error) {
    yield put({
      type: actionTypes.FAILURE_SET_COUNT_COMMUNICATION,
      message: error.message,
    });
  }
}

function* asyncremoveModifyCommunication({ payload }) {
  try {
    yield put({
      type: actionTypes.SUCCESS_MODIFY_COMMUNICATION,
      response: { data: payload },
      message: ''
    });
  } catch (error) {
    yield put({
      type: actionTypes.FAILURE_MODIFY_COMMUNICATION,
      message: error.message,
    });
  }
}

function* asyncSetHashCommunication({ payload }) {
  try {
    yield put({
      type: actionTypes.SUCCESS_HASH_COMMUNICATION,
      response: { data: payload },
      message: ''
    });
  } catch (error) {
    yield put({
      type: actionTypes.FAILURE_HASH_COMMUNICATION,
      message: error.message,
    });
  }
}


// Watchers
export default function* communicatedSaga() {
  yield takeLatest(actionTypes.GET_COMMUNICATION, asyncGetCommunication);
  yield takeLatest(actionTypes.GET_ALL_COMMUNICATION, asyncGetAllCommunications);
  yield takeLatest(actionTypes.GET_UPDATE_ALL_COMMUNICATION, asyncUpdateAllCommunications);
  yield takeLatest(actionTypes.MODIFY_COMMUNICATION, asyncModifyCommunication);
  yield takeLatest(actionTypes.SELECT_COMMUNICATION, asyncSelectCommunication);
  yield takeLatest(actionTypes.SET_COUNT_COMMUNICATION, asyncSetCount);
  yield takeLatest(actionTypes.RESET_MODIFY_COMMUNICATION, asyncremoveModifyCommunication);
  yield takeLatest(actionTypes.HASH_COMMUNICATION, asyncSetHashCommunication);


}
